import React, { useState } from 'react';
import { NextButton } from '../shared/Buttons';
import { FaUserTie } from 'react-icons/fa';

interface UserTypeFormProps {
  onContinue: (data: { userType: string }) => void;
  initialData?: string;
  isNextLoading?: boolean;
}

const UserTypeForm: React.FC<UserTypeFormProps> = ({ onContinue, initialData = '', isNextLoading = false }) => {
  const [userType, setUserType] = useState(initialData);

  const options = [
    'Founder / Startup Team',
    'Investor / VC / Accelerator',
    'Marketing / Sales Professional',
    'Consultant / Freelancer',
    'Corporate Executive / Manager',
    'Agency / Design Team',
    'Educator / Trainer',
    'Student / Individual Learner',
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserType(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userType) {
      onContinue({ userType });
    }
  };

  return (
    <div className="lg:p-0 p-2 w-full mt-[4rem] md:h-[90%] md:w-[80%] md:bg-white md:shadow-lg md:rounded-3xl md:flex md:flex-col md:items-center md:justify-between md:p-4">
      <div className="flex flex-col h-full w-full items-center ">
        <div className="flex flex-col items-center gap-1 p-2 lg:p-0">
          <FaUserTie className="text-[#3667B2] text-6xl lg:text-4xl xl:text-6xl mb-2" />
          <h1 className="text-2xl text-[#091220] font-bold">What best describes you?</h1>
        </div>
        <form onSubmit={handleSubmit} className="w-full max-w-sm mx-auto flex-grow flex flex-col justify-center">
          <div className="w-full py-4">
            <div className="flex flex-col gap-2">
              {options.map((option) => (
                <label key={option} className="flex items-center gap-2 cursor-pointer p-2 rounded hover:bg-gray-100">
                  <input
                    type="radio"
                    name="userType"
                    value={option}
                    checked={userType === option}
                    onChange={handleChange}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>
        </form>
        <div className="lg:w-[40%] w-full flex flex-col items-center p-2 mt-auto lg:pb-[8.5rem]">
          {isNextLoading ? (
            <div className="w-10 h-10 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
          ) : (
            <NextButton disabled={!userType} text={'Continue'} onClick={handleSubmit} />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserTypeForm;
